import diagram from "../../../../contents/images/blog/devrel-seed-grow-grow-more-diagram.png";
import * as React from 'react';
export default {
  diagram,
  React
};